import React from 'react';
import { useRef } from 'react';
import { Button, withStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import translate from '../../locales';
import { connect } from 'react-redux';
import { styleWithCommonClasses } from '../../_constants/emparkConstants';
import { useState } from 'react';
import { EmissionProfileSwitchTable } from '../Tables/EmissionProfileSwitchTable';


const __t = translate;

const styles = styleWithCommonClasses({
  buttonCancel: {
    '& span': {
      color: '#7b7c7d'
    }
  },
  error: {
    marginBottom: 10,
    textAlign: 'center',
    color: 'red',
  },
  tableContainer: {
    maxHeight: '40vh',
    overflowY: 'auto',
  }
})

const SwitchEmissionProfileTableDialog = props => {
  const { classes } = props;

  const [error, setError] = useState(null);

  const tableSubmitRef = useRef(null);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={props.open || false}
      onClose={props.onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{__t('emission_profiles')}</DialogTitle>
      <DialogContent>
        {error && <div className={classes.error}>{error}</div>}

        <div className={classes.tableContainer}>
          <EmissionProfileSwitchTable
            ref={tableSubmitRef}
            allEmissionProfiles={props.allEmissionProfiles}
            emissionProfiles={props.emissionProfiles}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button className={classes.buttonCancel} variant="outlined" color="primary" onClick={props.onCancel}>
          {__t('cancel')}
        </Button>
        <Button variant="outlined" color='primary' onClick={() => {
          const values = tableSubmitRef.current.getValues();

          props.onSubmit(values);
        }}
        >
          {__t('accept')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

function mapStateToProps(state) {
  return {

  }
}


function mapDispatchToProps(dispatch) {
  return {

  }
}

SwitchEmissionProfileTableDialog.propTypes = {
  open: PropTypes.bool,
  allEmissionProfiles: PropTypes.array,
  emissionProfiles: PropTypes.array,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(SwitchEmissionProfileTableDialog));